import { useQuery } from "@apollo/client";
import { IS_DENY_WAR_ENABLED } from "../queries/user_queries";

/**
 * Whether the broadcaster currently has deny wars turned on. Defaults to
 * disabled until the answer comes back so deny war numbers never flash on
 * screen for a broadcaster who turned the feature off.
 */
export const useDenyWarEnabled = () => {
  const { data, loading } = useQuery(IS_DENY_WAR_ENABLED);

  return {
    isDenyWarEnabled: data?.isDenyWarEnabled === true,
    loading,
  };
};

export default useDenyWarEnabled;
